// extracted by mini-css-extract-plugin
module.exports = {"Background":"NavBar_Background__wlaw4","Container":"NavBar_Container__k1iCw","Overlay":"NavBar_Overlay__xFeO5","SideMenu":"NavBar_SideMenu__EBNMv"};